import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import {
  InvitationAwaiting,
  InvitationBuilding,
} from "src/components/shared-components/class/general-classes/building";
import {
  InvitationState,
  UserInvitationResponse,
} from "src/components/shared-components/enum/enumLoginRegistrationResponse";
import { UsersRole } from "src/model/enum/enumDigitalPlace";
import { ThemeService } from "src/service/theme.service";

@Injectable({
  providedIn: "root",
})
export class InvitationService {
  _eventSubscriptions: Array<Subscription> = null;

  constructor(private _http: HttpClient, private _themeService: ThemeService) {}

  ngOnDestroy() {}

  /**
   * Get pending invitation
   */
  public getInvitationsByBuilding(
    idBuilding
  ): Promise<Array<InvitationBuilding>> {
    return this._http
      .get<Array<InvitationBuilding>>(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          "/listuserinvited/" +
          idBuilding
      )
      .toPromise();
  }

  /**
   * Get invitation by token
   * @param token
   * @returns
   */
  public getInvitationByToken(token: string): Promise<InvitationBuilding> {
    return this._http
      .get<InvitationBuilding>(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          "/getbytoken/" +
          token
      )
      .toPromise();
  }

  /**
   * Accept or decline invitation
   * @param id
   * @returns
   */
  public async acceptOrDeclineInvitation(
    token: string,
    operation: InvitationState
  ): Promise<UserInvitationResponse> {
    let url: string = "";
    if (operation == InvitationState.ACCEPTED) {
      url = "/accept";
    } else {
      url = "/decline";
    }

    return this._http
      .patch<UserInvitationResponse>(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          url +
          "?code=" +
          token +
          "&theme=" +
          this._themeService.applicationTheme,
        null
      )
      .toPromise();
  }

  /**
   * Accept or decline invitation
   * @param id
   * @returns
   */
  public async deleteInvitation(
    email: string,
    idBuilding: number
  ): Promise<void> {
    await this._http
      .delete(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          "/delete" +
          "?email=" +
          email +
          "&idBuilding=" +
          idBuilding
      )
      .toPromise();
  }

  /**
   * Get invitation awaiting
   * @param idUser
   */
  public getInvitationsAwaiting(email?: string) {
    const url =
      environment.httpDPAPIRoot +
      environment.anaciPlatformUser +
      AppSettings.API_URL_ANACI_INVITATION +
      "/invitationsawaiting" +
      (email ? "?email=" + email : "");
    return this._http.get<Array<InvitationAwaiting>>(url).toPromise();
  }

  /**
   * Send email activation
   * @param email
   * @returns
   */
  public async sendEmailActivation(email: String): Promise<boolean> {
    const bodyRequest = {
      email: email,
    };

    return this._http
      .post<boolean>(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          "/send/mail",
        { ...bodyRequest, theme: this._themeService.applicationTheme }
      )
      .toPromise();
  }

  /**
   * Send email
   * @param idBuilding
   * @param email
   * @param idUser
   * @returns
   */
  public async sendInviteEmail(
    idBuilding: number,
    email: string,
    idUser: number,
    role: UsersRole,
    idUserRemote: number = 0
  ) {
    const requestBody: any = {
      email: email,
      id: idUser,
      role: role,
    };

    if (idUserRemote > 0) {
      requestBody.idUserRemote = idUserRemote;
    }

    return this._http
      .post(
        environment.httpDPAPIRoot +
          environment.anaciPlatformUser +
          AppSettings.API_URL_ANACI_INVITATION +
          "/sendinvitation/" +
          idBuilding,
        { ...requestBody, theme: this._themeService.applicationTheme }
      )
      .toPromise();
  }
  //#endregion
}
